import {
  Component,
  OnInit,
  ViewChild,
  AfterViewInit,
  ElementRef
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { DialogService } from '@progress/kendo-angular-dialog';
import * as moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import { Store } from '@ngrx/store';
import { LDFlagSet } from 'launchdarkly-js-client-sdk';
import { AuthService } from '../../../authentication/_services/auth.service';
import { Permissions } from '../../../shared/Enums/Permissions';
import { ModalComponent } from '../../../modal/modal.component';
import { FUMCarrierService } from '../../../Services/fum-carrier.service';
import { FUMCarrier } from '../../models/FUMCarrier';
import { FUMCarrierSettingsComponent } from './fum-carrier-settings/fum-carrier-settings.component';
import { FUMCarrierAddressesComponent } from './fum-carrier-addresses/fum-carrier-addresses.component';
import { FUMCarrierAddressService } from '../../services/fum-carrier-address.service';
import { FUMCarrierAppUserRelationComponent } from './fum-carrier-appuser-relation/fum-carrier-appuser-relation.component';
import { FUMCarrierUserRelationService } from '../../services/fum-carrier-association.service';
import { FUMCarrierCertificationComponent } from './fum-carrier-certifications/fum-carrier-certifications.component';
import { FUMCarrierNoteComponent } from './fum-carrier-notes/fum-carrier-notes.component';
import { FUMCarrierContactsComponent } from './fum-carrier-contacts/fum-carrier-contacts.component';
import { FUMCarrierNoteService } from '../../services/fum-carrier-note.service';
import { FUMCarrierContactService } from '../../services/fum-carrier-contact.service';
import { FUMCarrierDocumentComponent } from './fum-carrier-documents/fum-carrier-documents.component';
import { FUMCarrierDocumentService } from '../../services/fum-carrier-document.service';
import { FUMCarrierInsuranceService } from '../../services/fum-carrier-insurance.service';
import { FUMCarrierInsuranceComponent } from './fum-carrier-insurance/fum-carrier-insurance.component';
import { FUMCarrierIdentityComponent } from './fum-carrier-identity/fum-carrier-identity.component';
import { CarrierAddress } from '../../models/CarrierAddress';
import { CarrierAssociation } from '../../models/CarrierAssociation';
import { CarrierNote } from '../../models/CarrierNote';
import { CarrierContact } from '../../models/CarrierContact';
import { CarrierContactVerificationStatus } from '../../models/CarrierContact';
import { CarrierDocument } from '../../models/CarrierDocument';
import { CarrierInsurance } from '../../models/CarrierInsurance';
import { CarrierLoadHistoryService } from '../../services/carrier-load-history.service';
import { CarrierOfferComponent } from '../../../shared/carrier-offer/carrier-offer.component';
import { CarrierOfferService } from '../../../shared/carrier-offer/carrier-offer.service';
import { LoadHistoryDC } from '../../models/LoadHistoryDC';
import { Configuration } from '../../../shared/configuration/Configuration';
import { AppState } from '../../../appstate.model';
import { FUMEnterprise } from '../../models/FUMEnterprise';
import { FUMEnterpriseService } from '../../services/fum-enterprise.service';
import { FUMEnterpriseComponent } from './fum-enterprise/fum-enterprise.component';
import { CarrierOfferPayload } from '../../../shared/carrier-offer/CarrierOfferDC';
import { FEATURE_FLAGS } from '../../../shared/feature-flag/feature-flag.service';

@Component({
  selector: 'fum-truckload-carrier-file',
  templateUrl: './fum-carrier-file.component.html',
  styleUrls: ['./fum-carrier-file.component.scss']
})
export class FUMCarrierFileComponent implements OnInit, AfterViewInit {
  @ViewChild('detailMain', { static: false }) detailMain: ElementRef;
  @ViewChild('detailBody', { static: false }) detailBody: ElementRef;
  @ViewChild('settingsModal', { static: false }) settingsModal: ModalComponent;
  @ViewChild('editSettingsForm', { static: false })
  editSettingsForm: FUMCarrierSettingsComponent;
  @ViewChild('addressModal', { static: false }) addressModal: ModalComponent;
  @ViewChild('addressForm', { static: false })
  addressForm: FUMCarrierAddressesComponent;
  @ViewChild('addressDeleteConfirmationModal', { static: false })
  addressDeleteConfirmationModal: ModalComponent;
  @ViewChild('repAssociationModal', { static: false })
  repAssociationModal: ModalComponent;
  @ViewChild('repAssociationForm', { static: false })
  repAssociationForm: FUMCarrierAppUserRelationComponent;
  @ViewChild('repAssociationDeleteConfirmationModal', { static: false })
  repAssociationDeleteConfirmationModal: ModalComponent;
  @ViewChild('customerAssociationModal', { static: false })
  customerAssociationModal: ModalComponent;
  @ViewChild('customerAssociationForm', { static: false })
  customerAssociationForm: FUMEnterpriseComponent;
  @ViewChild('customerAssociationDeleteConfirmationModal', { static: false })
  customerAssociationDeleteConfirmationModal: ModalComponent;
  @ViewChild('identityModal', { static: false })
  identityModal: ModalComponent;
  @ViewChild('identityForm', { static: false })
  identityForm: FUMCarrierIdentityComponent;
  @ViewChild('certificationModal', { static: false })
  certificationModal: ModalComponent;
  @ViewChild('certificationForm', { static: false })
  certificationForm: FUMCarrierCertificationComponent;
  @ViewChild('notesModal', { static: false }) notesModal: ModalComponent;
  @ViewChild('notesForm', { static: false }) notesForm: FUMCarrierNoteComponent;
  @ViewChild('noteDeleteConfirmationModal', { static: false })
  noteDeleteConfirmationModal: ModalComponent;
  @ViewChild('contactsModal', { static: false }) contactsModal: ModalComponent;
  @ViewChild('contactsForm', { static: false })
  contactsForm: FUMCarrierContactsComponent;
  @ViewChild('contactDeleteConfirmationModal', { static: false })
  contactDeleteConfirmationModal: ModalComponent;
  @ViewChild('documentsModal', { static: false })
  documentsModal: ModalComponent;
  @ViewChild('documentsForm', { static: false })
  documentsForm: FUMCarrierDocumentComponent;
  @ViewChild('documentDeleteConfirmationModal', { static: false })
  documentDeleteConfirmationModal: ModalComponent;
  @ViewChild('contactDeleteDocumentModal', { static: false })
  documentDeleteModal: ModalComponent;
  @ViewChild('insuranceModal', { static: false })
  insuranceModal: ModalComponent;
  @ViewChild('insuranceForm', { static: false })
  insuranceForm: FUMCarrierInsuranceComponent;
  @ViewChild('insuranceDeleteConfirmationModal', { static: false })
  insuranceDeleteConfirmationModal: ModalComponent;
  @ViewChild('downloadZipLink', { static: true }) downloadZipLink: ElementRef;

  @ViewChild('associationIdentities', { static: false })
  associationIdentitiesSection: ElementRef;
  @ViewChild('addresses', { static: false })
  addressesSection: ElementRef;
  @ViewChild('certificationsNotes', { static: false })
  certificationsNotesSection: ElementRef;
  @ViewChild('contacts', { static: false })
  contactsSection: ElementRef;
  @ViewChild('settingsDocuments', { static: false })
  settingsDocumentsSection: ElementRef;
  @ViewChild('insurance', { static: false })
  insuranceSection: ElementRef;
  @ViewChild('loadHistory', { static: false })
  loadHistorySection: ElementRef;

  carrierCode: string;
  fumCarrierFile: FUMCarrier;
  addressForEdit: CarrierAddress;
  addressForDelete: CarrierAddress;
  repAssociationForDelete: CarrierAssociation;
  customerAssociationForDelete: FUMEnterprise;
  noteForDelete: CarrierNote;
  contactForEdit: CarrierContact;
  contactForDelete: CarrierContact;
  documentForEdit: CarrierDocument;
  documentForDelete: CarrierDocument;
  mainRep: CarrierAssociation;
  primaryContact: CarrierContact;
  cargoInsurance: CarrierInsurance;
  insuranceGridData: CarrierInsurance[];
  insuranceForEdit: CarrierInsurance;
  insuranceForDelete: CarrierInsurance;
  showInactiveInsurance = false;
  FUMCarrierViews = FUMCarrierViews;
  loadHistoryData: LoadHistoryDC[];
  config: Configuration;
  currentView: FUMCarrierViews = FUMCarrierViews.AssociationIdentities;
  isLoadingCounter: number = 0;
  flags: LDFlagSet;

  constructor(
    public activatedRoute: ActivatedRoute,
    private router: Router,
    public fumCarrierService: FUMCarrierService,
    public authService: AuthService,
    public loadHistorySvc: CarrierLoadHistoryService,
    public fumCarrierAddressService: FUMCarrierAddressService,
    private fumCarrierUserRelationService: FUMCarrierUserRelationService,
    private fumEnterpriseService: FUMEnterpriseService,
    public fumCarrierNoteService: FUMCarrierNoteService,
    public fumCarrierContactService: FUMCarrierContactService,
    public fumCarrierDocumentService: FUMCarrierDocumentService,
    public fumCarrierInsuranceService: FUMCarrierInsuranceService,
    private carrierOfferService: CarrierOfferService,
    private dialogService: DialogService,
    private toastr: ToastrService,
    private location: Location,
    private store: Store<AppState>
  ) {
    // TODO: Fix store subscription leaks
    this.store
      .select((x) => x.Configuration)
      .subscribe((x) => {
        this.config = x;
      });

    this.store
      .select((x) => x.FeatureFlags)
      .subscribe((ld) => {
        this.flags = ld.flags;

        if (
          this.flags[FEATURE_FLAGS.useV3CarrierOffers] !== undefined &&
          this.flags[FEATURE_FLAGS.useV3CarrierOffers].current !== undefined
        ) {
          this.flags[FEATURE_FLAGS.useV3CarrierOffers] =
            this.flags[FEATURE_FLAGS.useV3CarrierOffers].current;
        }
      });
  }

  ngOnInit() {
    this.activatedRoute.params.subscribe((params) => {
      this.carrierCode = params['id'];
      if (!this.carrierCode) {
        this.router.navigate(['/carrier/search']);
      }
    });
    this.loadFUMCarrierFile();
    this.getLoadHistory();
  }

  ngAfterViewInit(): void {
    this.setDetailMainHeight();
  }

  scrollHandler(event) {
    const containerTopValue = event.target.getBoundingClientRect().top;

    if (
      !this.handleSelectingMenu(
        containerTopValue,
        this.associationIdentitiesSection,
        FUMCarrierViews.AssociationIdentities
      )
    ) {
      return;
    }

    if (
      !this.handleSelectingMenu(
        containerTopValue,
        this.addressesSection,
        FUMCarrierViews.Addresses
      )
    ) {
      return;
    }

    if (
      !this.handleSelectingMenu(
        containerTopValue,
        this.certificationsNotesSection,
        FUMCarrierViews.CertificationsNotes
      )
    ) {
      return;
    }

    if (
      !this.handleSelectingMenu(
        containerTopValue,
        this.contactsSection,
        FUMCarrierViews.Contacts
      )
    ) {
      return;
    }

    if (
      !this.handleSelectingMenu(
        containerTopValue,
        this.settingsDocumentsSection,
        FUMCarrierViews.SettingsDocuments
      )
    ) {
      return;
    }

    if (
      !this.handleSelectingMenu(
        containerTopValue,
        this.insuranceSection,
        FUMCarrierViews.Insurance
      )
    ) {
      return;
    }

    if (
      !this.handleSelectingMenu(
        containerTopValue,
        this.loadHistorySection,
        FUMCarrierViews.LoadHistory
      )
    ) {
      return;
    }
  }
  private handleSelectingMenu(
    containerTopValue: number,
    currentChildElement: ElementRef,
    currentChildView: FUMCarrierViews
  ): boolean {
    const offset = 40; // Used as leeway or buffer when comparing to container

    let childTopValue =
      currentChildElement.nativeElement.getBoundingClientRect().top;

    const isNearContainerTop = containerTopValue >= childTopValue - offset;

    if (isNearContainerTop) {
      this.currentView = currentChildView;
      return true;
    } else {
      return false;
    }
  }

  setDetailMainHeight(): void {
    if (this.fumCarrierFile) {
      const childHeight = this.detailBody.nativeElement.offsetHeight;

      this.detailMain.nativeElement.style.height = `${childHeight * 1.35}px`;
    } else {
      setTimeout(() => {
        this.setDetailMainHeight();
      }, 50);
    }
  }

  getLoadHistory(): void {
    this.isLoadingCounter++;

    this.loadHistorySvc.get(this.carrierCode).subscribe(
      (data) => {
        this.loadHistoryData = data;

        this.isLoadingCounter--;
      },
      (err) => {
        this.isLoadingCounter--;

        this.toastr.error(
          `<div class="mt-2" style="width: 100%;">Error: "${
            err.error
              ? !err.error.error
                ? err.error
                : err.error.error
              : err.message
          }"<div>`,
          'FUM Carrier Load History Could Not Be Loaded!'
        );
      }
    );
  }

  getAddresses(): void {
    this.isLoadingCounter++;
    this.fumCarrierAddressService.get(this.carrierCode).subscribe(
      (data: CarrierAddress[]) => {
        this.organizeCarrierAddressData(data);

        this.isLoadingCounter--;
      },
      (err) => {
        this.isLoadingCounter--;

        this.toastr.error(
          `<div class="mt-2" style="width: 100%;">Error: "${
            err.error
              ? !err.error.error
                ? err.error
                : err.error.error
              : err.message
          }"<div>`,
          'FUM Carrier Addresses Could Not Be Loaded!'
        );
      }
    );
  }

  getRepAssociations(): void {
    this.isLoadingCounter++;

    this.fumCarrierUserRelationService.get(this.carrierCode).subscribe(
      (data: CarrierAssociation[]) => {
        this.organizeCarrierRepAssociationData(data);

        this.isLoadingCounter--;
      },
      (err) => {
        this.isLoadingCounter--;

        this.toastr.error(
          `<div class="mt-2" style="width: 100%;">Error: "${
            err.error
              ? !err.error.error
                ? err.error
                : err.error.error
              : err.message
          }"<div>`,
          'FUM Carrier Associations Could Not Be Loaded!'
        );
      }
    );
  }

  getCustomerAssociations(): void {
    this.isLoadingCounter++;

    this.fumEnterpriseService.getByCarrierCode(this.carrierCode).subscribe(
      (data: FUMEnterprise[]) => {
        this.organizeCarrierCustomerAssociationData(data);

        this.isLoadingCounter--;
      },
      (err) => {
        this.isLoadingCounter--;

        this.toastr.error(
          `<div class="mt-2" style="width: 100%;">Error: "${
            err.error
              ? !err.error.error
                ? err.error
                : err.error.error
              : err.message
          }"<div>`,
          'FUM Carrier Associations Could Not Be Loaded!'
        );
      }
    );
  }

  organizeCarrierRepAssociationData(data: CarrierAssociation[]): void {
    this.fumCarrierFile.carrierUserRelations = data;

    this.mainRep = this.fumCarrierFile.carrierUserRelations.find(
      (userRep) => userRep.isRep
    );

    this.fumCarrierFile.carrierUserRelations.sort((a, b) => {
      if (a.firstName === b.firstName) {
        return a.lastName < b.lastName ? -1 : 1;
      }
      return a.firstName < b.firstName ? -1 : 1;
    });

    this.fumCarrierFile.carrierUserRelations.sort((a, b) => {
      return a.isRep === b.isRep ? 0 : a.isRep ? -1 : 1;
    });
  }

  organizeCarrierCustomerAssociationData(data: FUMEnterprise[]): void {
    this.fumCarrierFile.enterprises = data;

    this.fumCarrierFile.enterprises.sort((a, b) => {
      return a.name < b.name ? -1 : 1;
    });
  }

  organizeCarrierAddressData(data: CarrierAddress[]): void {
    this.fumCarrierFile.carrierAddresses = data;
  }

  organizeCarrierContactData(data: CarrierContact[]): void {
    this.fumCarrierFile.carrierContacts = data;

    this.primaryContact = this.fumCarrierFile.carrierContacts.find(
      (contact) => contact.isPrimary
    );

    this.fumCarrierFile.carrierContacts.map((contact) => {
      contact.verificationStatus =
        contact.verificationStatus ||
        CarrierContactVerificationStatus.Unverified;
    });
  }

  organizeCarrierDocumentData(data: CarrierDocument[]): void {
    this.fumCarrierFile.carrierDocuments = data;

    this.fumCarrierFile.carrierDocuments.sort((a, b) => {
      return (
        new Date(b.dateUpdated).getTime() - new Date(a.dateUpdated).getTime()
      );
    });

    this.fumCarrierFile.carrierDocuments.map((document) => {
      document.dateUpdatedFormatted = this.formatDate(document.dateUpdated);
    });
  }

  organizeCarrierInsuranceData(data: CarrierInsurance[]): void {
    this.fumCarrierFile.carrierInsurances = data;

    this.cargoInsurance = this.fumCarrierFile.carrierInsurances.find(
      (insurance) => insurance.type == 'CARGO'
    );

    this.fumCarrierFile.carrierInsurances.map((insurance) => {
      // must dates convert to JS date objects, for kendo tools to bind correctly
      insurance.expirationDate = insurance.expirationDate
        ? new Date(insurance.expirationDate)
        : null;
      insurance.effectiveDate = insurance.effectiveDate
        ? new Date(insurance.effectiveDate)
        : null;
      insurance.cancelDate = insurance.cancelDate
        ? new Date(insurance.cancelDate)
        : null;
      insurance.expirationDateFormatted = this.formatDate(
        insurance.expirationDate
      );
      insurance.effectiveDateFormatted = this.formatDate(
        insurance.effectiveDate
      );
      insurance.cancelDateFormatted = this.formatDate(insurance.cancelDate);
    });
  }

  organizeCarrierNoteData(data: CarrierNote[]): void {
    this.fumCarrierFile.carrierNotes = data;

    this.fumCarrierFile.carrierNotes.sort((a, b) => {
      return (
        new Date(b.dateCreated).getTime() - new Date(a.dateCreated).getTime()
      );
    });

    this.fumCarrierFile.carrierNotes.map((note) => {
      note.dateCreatedFormatted = this.formatDate(note.dateCreated);
    });
  }

  loadFUMCarrierFile(): void {
    this.isLoadingCounter++;

    this.fumCarrierService.getAggregate(this.carrierCode).subscribe(
      (data) => {
        this.fumCarrierFile = data;

        this.organizeCarrierRepAssociationData(
          this.fumCarrierFile.carrierUserRelations
        );

        this.organizeCarrierAddressData(this.fumCarrierFile.carrierAddresses);

        this.organizeCarrierContactData(this.fumCarrierFile.carrierContacts);

        this.organizeCarrierDocumentData(this.fumCarrierFile.carrierDocuments);

        this.organizeCarrierInsuranceData(
          this.fumCarrierFile.carrierInsurances
        );

        this.organizeCarrierNoteData(this.fumCarrierFile.carrierNotes);

        this.applyInsuranceToggle();

        setTimeout(() => {
          let jumpLink =
            this.router.url.split('%23').length > 1
              ? this.router.url.split('%23')[1]
              : this.router.url.split('#')[1];
          this.navJumpLink(jumpLink);
        }, 50);

        this.isLoadingCounter--;
      },
      (err) => {
        this.isLoadingCounter--;

        this.toastr.error(
          `<div class="mt-2" style="width: 100%;">Error: "${
            err.error
              ? !err.error.error
                ? err.error
                : err.error.error
              : err.message
          }"<div>`,
          'FUM Carrier Could Not Be Loaded!'
        );
        this.router.navigate(['/search']);
      }
    );
  }

  private formatDate(date: Date): string | null {
    if (!date) return null;

    const dateResult = new Date(date);
    const pad = (num) => num.toString().padStart(2, '0');

    return `${pad(dateResult.getMonth() + 1)}/${pad(dateResult.getDate())}/${dateResult.getFullYear()} ${pad(dateResult.getHours())}:${pad(dateResult.getMinutes())}`;
  }

  openSettingsModal(): void {
    const optionsModal = {
      width: 500,
      title: 'Edit FUM Carrier Settings',
      resizable: false
    };

    this.editSettingsForm.resetForm();
    this.settingsModal.showConfirmation(optionsModal);
  }

  openAddAddressModal(): void {
    const optionsModal = {
      width: 1200,
      title: 'Add FUM Carrier Address',
      resizable: false
    };
    this.addressForEdit = null;

    setTimeout(() => {
      this.addressForm.resetForm();
      this.addressModal.showConfirmation(optionsModal);
    }, 5);
  }

  openEditAddressModal(address: CarrierAddress): void {
    const optionsModal = {
      width: 1200,
      title: 'Edit FUM Carrier Address',
      resizable: false
    };
    this.addressForEdit = address;

    setTimeout(() => {
      this.addressForm.resetForm();
      this.addressModal.showConfirmation(optionsModal);
    }, 5);
  }

  openAddRepAssociationModal(): void {
    const optionsModal = {
      width: 800,
      title: 'Add FUM Carrier/AppUser Association',
      resizable: false
    };
    this.repAssociationForm.resetForm();

    this.repAssociationModal.showConfirmation(optionsModal);
  }

  openAddCustomerAssociationModal(): void {
    const optionsModal = {
      width: 800,
      title: 'Add FUM Carrier/Customer Association',
      resizable: false
    };
    this.customerAssociationForm.resetForm();

    this.customerAssociationModal.showConfirmation(optionsModal);
  }

  openEditIdentityModal(): void {
    const optionsModal = {
      width: 800,
      title: 'Edit FUM Carrier Identities',
      resizable: false
    };
    this.identityForm.resetForm();

    this.identityModal.showConfirmation(optionsModal);
  }

  openEditCertificationModal(): void {
    const optionsModal = {
      width: 550,
      title: 'Add/Remove FUM Carrier Certification(s)',
      resizable: false
    };
    this.certificationForm.resetForm();

    this.certificationModal.showConfirmation(optionsModal);
  }

  openAddNotesModal(): void {
    const optionsModal = {
      width: 450,
      title: 'Add FUM Carrier Note',
      resizable: false
    };

    this.notesForm.resetForm();
    this.notesModal.showConfirmation(optionsModal);
  }

  openAddContactModal(): void {
    const optionsModal = {
      width: 800,
      title: 'Add FUM Carrier Contact',
      resizable: false
    };
    this.contactForEdit = null;

    setTimeout(() => {
      this.contactsForm.resetForm();
      this.contactsModal.showConfirmation(optionsModal);
    }, 5);
  }

  openEditContactModal(contact: CarrierContact): void {
    const optionsModal = {
      width: 800,
      title: 'Edit FUM Carrier Contact',
      resizable: false
    };
    this.contactForEdit = contact;

    setTimeout(() => {
      this.contactsForm.resetForm();
      this.contactsModal.showConfirmation(optionsModal);
    }, 5);
  }

  openAddDocumentModal(): void {
    const optionsModal = {
      width: 650,
      title: 'Add FUM Carrier Document',
      resizable: false
    };
    this.documentForEdit = null;

    setTimeout(() => {
      this.documentsForm.resetForm();
      this.documentsModal.showConfirmation(optionsModal);
    }, 5);
  }

  openEditDocumentModal(document: CarrierDocument): void {
    const optionsModal = {
      width: 650,
      title: 'Edit FUM Carrier Document',
      resizable: false
    };
    this.documentForEdit = document;

    setTimeout(() => {
      this.documentsForm.resetForm();
      this.documentsModal.showConfirmation(optionsModal);
    }, 5);
  }

  openAddInsuranceModal(): void {
    const optionsModal = {
      width: 850,
      title: 'Add FUM Carrier Insurance',
      resizable: false
    };
    this.insuranceForEdit = null;

    setTimeout(() => {
      this.insuranceForm.resetForm();
      this.insuranceModal.showConfirmation(optionsModal);
    }, 5);
  }

  openEditInsuranceModal(insurance: CarrierInsurance): void {
    const optionsModal = {
      width: 800,
      title: 'Edit FUM Carrier Insurance',
      resizable: false
    };
    this.insuranceForEdit = insurance;

    setTimeout(() => {
      this.insuranceForm.resetForm();
      this.insuranceModal.showConfirmation(optionsModal);
    }, 5);
  }

  closeStatusModal(): void {
    this.settingsModal.closeModal();
    this.loadFUMCarrierFile();
  }

  closeAddressModal(): void {
    this.addressModal.closeModal();
    this.getAddresses();
  }

  closeRepAssociationModal(): void {
    this.repAssociationModal.closeModal();
    this.getRepAssociations();
  }

  closeCustomerAssociationModal(): void {
    this.customerAssociationModal.closeModal();
    this.getCustomerAssociations();
  }

  closeIdentityModal(): void {
    this.identityModal.closeModal();
    this.loadFUMCarrierFile();
  }

  closeCertificationModal(): void {
    this.certificationModal.closeModal();
    this.loadFUMCarrierFile();
  }

  closeContactsModal(): void {
    this.contactsModal.closeModal();
    this.loadFUMCarrierFile();
  }

  closeDocumentsModal(): void {
    this.documentsModal.closeModal();
    this.loadFUMCarrierFile();
  }

  closeInsuranceModal(): void {
    this.insuranceModal.closeModal();
    this.loadFUMCarrierFile();
  }

  closeNotesModal(): void {
    this.notesModal.closeModal();
    this.loadFUMCarrierFile();
  }

  confirmAddressDelete(address: CarrierAddress): void {
    this.addressForDelete = address;
    const optionsModal = {
      width: 500,
      title: 'Delete Address',
      resizable: false
    };

    this.addressDeleteConfirmationModal.showConfirmation(optionsModal);
  }

  confirmRepAssociationDelete(association: CarrierAssociation): void {
    this.repAssociationForDelete = association;
    const optionsModal = {
      width: 500,
      title: 'Delete Carrier/AppUser Association',
      resizable: false
    };

    this.repAssociationDeleteConfirmationModal.showConfirmation(optionsModal);
  }

  confirmCustomerAssociationDelete(fumEnterprise: FUMEnterprise): void {
    this.customerAssociationForDelete = fumEnterprise;
    const optionsModal = {
      width: 500,
      title: 'Delete Carrier/Customer Association',
      resizable: false
    };

    this.customerAssociationDeleteConfirmationModal.showConfirmation(
      optionsModal
    );
  }

  confirmContactDelete(contact: CarrierContact): void {
    this.contactForDelete = contact;
    const optionsModal = {
      width: 500,
      title: 'Delete Carrier Contact',
      resizable: false
    };

    this.contactDeleteConfirmationModal.showConfirmation(optionsModal);
  }

  confirmDocumentDelete(document: CarrierDocument): void {
    this.documentForDelete = document;
    const optionsModal = {
      width: 500,
      title: 'Delete Carrier Document',
      resizable: false
    };

    this.documentDeleteConfirmationModal.showConfirmation(optionsModal);
  }

  confirmNoteDelete(note: CarrierNote): void {
    this.noteForDelete = note;
    const optionsModal = {
      width: 500,
      title: 'Delete Carrier Note',
      resizable: false
    };

    this.noteDeleteConfirmationModal.showConfirmation(optionsModal);
  }

  confirmInsuranceDelete(insurance: CarrierInsurance): void {
    this.insuranceForDelete = insurance;
    const optionsModal = {
      width: 500,
      title: 'Delete Carrier Insurance',
      resizable: false
    };

    this.insuranceDeleteConfirmationModal.showConfirmation(optionsModal);
  }

  downloadDocument(carrierDocument: CarrierDocument) {
    this.fumCarrierDocumentService
      .download(carrierDocument.carrierDocumentID)
      .subscribe((blob) => {
        const url = window.URL.createObjectURL(blob);
        const link = this.downloadZipLink.nativeElement;
        link.href = url;
        link.download = carrierDocument.contentUrl;
        link.click();
        window.URL.revokeObjectURL(url);
      });
  }

  deleteAddress(): void {
    this.addressDeleteConfirmationModal.closeModal();
    this.fumCarrierAddressService
      .delete(this.addressForDelete.carrierAddressID)
      .subscribe(
        () => {
          this.toastr.success(
            'FUM Carrier Address Deleted Successfully!',
            'Success'
          );
          this.getAddresses();
        },
        (err) => {
          this.toastr.error(
            `<div class="mt-2" style="width: 100%;">Error: "${
              err.error
                ? !err.error.error
                  ? err.error
                  : err.error.error
                : err.message
            }"<div>`,
            `FUM Carrier Address Could Not Be Deleted!`
          );
        }
      );

    this.addressForDelete = null;
  }

  deleteRepAssociation(): void {
    this.repAssociationDeleteConfirmationModal.closeModal();
    this.fumCarrierUserRelationService
      .delete(this.repAssociationForDelete.carrierAppUserRelationID)
      .subscribe(
        () => {
          this.toastr.success(
            'FUM Carrier/AppUser Association Deleted Successfully!',
            'Success'
          );
          this.getRepAssociations();
        },
        (err) => {
          this.toastr.error(
            `<div class="mt-2" style="width: 100%;">Error: "
          ${
            err.error
              ? !err.error.error
                ? err.error
                : err.error.error
              : err.message
          }"<div>`,
            `FUM Carrier/AppUser Association Could Not Be Deleted!`
          );
        }
      );

    this.repAssociationForDelete = null;
  }

  deleteCustomerAssociation(): void {
    this.customerAssociationDeleteConfirmationModal.closeModal();

    this.fumEnterpriseService
      .deleteAssociation(
        this.fumCarrierFile.carrierID,
        this.customerAssociationForDelete.enterpriseID
      )
      .subscribe(
        () => {
          this.toastr.success(
            'FUM Carrier/Customer Association Deleted Successfully!',
            'Success'
          );
          this.getCustomerAssociations();
        },
        (err) => {
          this.toastr.error(
            `<div class="mt-2" style="width: 100%;">Error: "
          ${
            err.error
              ? !err.error.error
                ? err.error
                : err.error.error
              : err.message
          }"<div>`,
            `FUM Carrier/Customer Association Could Not Be Deleted!`
          );
        }
      );

    this.customerAssociationForDelete = null;
  }

  deleteContact(): void {
    this.contactDeleteConfirmationModal.closeModal();
    this.fumCarrierContactService
      .delete(this.contactForDelete.carrierContactID)
      .subscribe(
        () => {
          this.toastr.success(
            'FUM Carrier Contact Deleted Successfully!',
            'Success'
          );
          this.loadFUMCarrierFile();
        },
        (err) => {
          this.toastr.error(
            `<div class="mt-2" style="width: 100%;">Error: "${
              err.error
                ? !err.error.error
                  ? err.error
                  : err.error.error
                : err.message
            }"<div>`,
            `FUM Carrier Contact Could Not Be Deleted!`
          );
        }
      );

    this.contactForDelete = null;
  }

  deleteDocument(): void {
    this.documentDeleteConfirmationModal.closeModal();
    this.fumCarrierDocumentService
      .delete(this.documentForDelete.carrierDocumentID)
      .subscribe(
        () => {
          this.toastr.success(
            'FUM Carrier Contact Deleted Successfully!',
            'Success'
          );
          this.loadFUMCarrierFile();
        },
        (err) => {
          this.toastr.error(
            `<div class="mt-2" style="width: 100%;">Error: "${
              err.error
                ? !err.error.error
                  ? err.error
                  : err.error.error
                : err.message
            }"<div>`,
            `FUM Carrier Contact Could Not Be Deleted!`
          );
        }
      );

    this.documentForDelete = null;
  }

  deleteNote(): void {
    this.noteDeleteConfirmationModal.closeModal();
    this.fumCarrierNoteService
      .delete(this.noteForDelete.carrierNoteID)
      .subscribe(
        () => {
          this.toastr.success(
            'FUM Carrier Note Deleted Successfully!',
            'Success'
          );
          this.loadFUMCarrierFile();
        },
        (err) => {
          this.toastr.error(
            `<div class="mt-2" style="width: 100%;">Error: "${
              err.error
                ? !err.error.error
                  ? err.error
                  : err.error.error
                : err.message
            }"<div>`,
            `FUM Carrier Note Could Not Be Deleted!`
          );
        }
      );

    this.noteForDelete = null;
  }

  deleteInsurance(): void {
    this.insuranceDeleteConfirmationModal.closeModal();
    this.fumCarrierInsuranceService
      .delete(this.insuranceForDelete.carrierInsuranceID)
      .subscribe(
        () => {
          this.toastr.success(
            'FUM Carrier Insurance Deleted Successfully!',
            'Success'
          );
          this.loadFUMCarrierFile();
        },
        (err) => {
          this.toastr.error(
            `<div class="mt-2" style="width: 100%;">Error: "${
              err.error
                ? !err.error.error
                  ? err.error
                  : err.error.error
                : err.message
            }"<div>`,
            `FUM Carrier Insurance Could Not Be Deleted!`
          );
        }
      );

    this.insuranceForDelete = null;
  }

  navJumpLink(jumpLink): void {
    if (jumpLink) {
      let baseUrl =
        this.router.url.split('%23').length > 1
          ? this.router.url.split('%23')[0]
          : this.router.url.split('#')[0];
      let currentUrl = `${baseUrl}#${jumpLink}`;
      this.currentView = jumpLink;

      this.location.go(currentUrl);
      this.router.navigateByUrl(currentUrl);

      document.getElementById(jumpLink).scrollIntoView();
    }
  }

  applyInsuranceToggle() {
    this.insuranceGridData = this.fumCarrierFile.carrierInsurances.filter(
      (x) => this.showInactiveInsurance || x.status.toUpperCase() === 'VALID'
    );
  }

  setIncludeInactiveRecords() {
    this.showInactiveInsurance = !this.showInactiveInsurance;
    this.applyInsuranceToggle();
  }

  showOfferDialog(): void {
    const offerRef = this.dialogService.open({
      content: CarrierOfferComponent,
      width: 800
    });

    const instance = offerRef.content.instance;

    instance.carrierSummary = this.fumCarrierFile;
    instance.ff_useV3CarrierOffers =
      this.flags[FEATURE_FLAGS.useV3CarrierOffers];

    offerRef.result.toPromise().then((dialogResult: any) => {
      if (!dialogResult.result) {
        return;
      }

      const effectiveDate = moment(new Date()).format('L');
      const currencyCode: string = dialogResult.result.currencyCode;

      this.carrierOfferService
        .getOfferPrerequisites(effectiveDate, currencyCode)
        .then((prerequisits) => {
          const { rate, userDetails } = prerequisits;
          const convertedBuyRate = dialogResult.result.buyRate / rate;

          const offer: CarrierOfferPayload = {
            v1Offer: {
              carrierCode: this.fumCarrierFile.carrierCode,
              carrierName: this.fumCarrierFile.carrierName,
              dotNumber: this.fumCarrierFile.dotNumber,
              mcNumber: this.fumCarrierFile.mcNumber,
              scac: this.fumCarrierFile.scac,
              currencyCode: currencyCode,
              carrierChargeInUSD: convertedBuyRate,
              carrierCharge: dialogResult.result.buyRate,
              customerCharge: 0,
              notes: dialogResult.result.quoteNote
            },
            v3Offer: {
              fumCarrierID: this.fumCarrierFile.carrierID,
              condition: dialogResult.result.condition,
              note: dialogResult.result.quoteNote,
              rate: dialogResult.result.buyRate
            }
          };

          return this.carrierOfferService
            .submitOffer(dialogResult.result.shipmentID, userDetails, offer)
            .toPromise();
        })
        .then(
          () => {
            this.toastr.success(
              'FUM Carrier Offer/Quote Created Successfully!',
              'Success'
            );
          },
          (err) => {
            this.toastr.error(
              `<div class="mt-2" style="width: 100%;">Error: "${
                err.error
                  ? !err.error.error
                    ? err.error
                    : err.error.error
                  : err.message
              }"<div>`,
              'FUM Carrier Offer/Quote Could Not Be Updated!'
            );
          }
        );
    });
  }

  goToCarrierOffer(loadHistory: LoadHistoryDC) {
    window.open(
      `${this.config.backofficeShipmentEditUrl}/shipment-edit/${loadHistory.shipmentID}`
    );
  }

  get fumCarrierFileArray() {
    return [this.fumCarrierFile];
  }

  get canCreateOfferFromDetails(): boolean {
    return this.authService.can(Permissions.EditFumCarrier);
  }

  get canEditBGStatus(): boolean {
    return this.authService.can(Permissions.EditFumCarrier);
  }

  get canEditAddresses(): boolean {
    return this.authService.can(Permissions.EditFumCarrier);
  }

  get canDeleteCustomerAssociation(): boolean {
    return (
      this.fumCarrierFile &&
      this.fumCarrierFile.enterprises.length > 1 &&
      this.authService.can(Permissions.EditFumCarrier)
    );
  }

  get canDeleteContacts(): boolean {
    return this.authService.can(Permissions.EditFumCarrier);
  }

  get canEditContacts(): boolean {
    return this.authService.can(Permissions.EditFumCarrier);
  }

  get canEditDocuments(): boolean {
    return this.authService.can(Permissions.EditFumCarrier);
  }

  get canDeleteDocuments(): boolean {
    return this.authService.can(Permissions.EditFumCarrier);
  }

  get canEditInsurance(): boolean {
    return this.authService.can(Permissions.EditFumCarrier);
  }

  get canDeleteInsurance(): boolean {
    return this.authService.can(Permissions.EditFumCarrier);
  }

  get canViewLoadHistory(): boolean {
    return true; // Not hidden by this permission at this time - this.authService.can(Permissions.ViewLoadHistory);
  }

  get canEditCustomerAssociations(): boolean {
    return this.authService.can(Permissions.EditFumCarrier);
  }

  get canEditRepAssociations(): boolean {
    return this.authService.can(Permissions.EditFumCarrier);
  }

  get canEditIdentities(): boolean {
    return this.authService.can(Permissions.EditFumCarrier);
  }

  get canEditCertifications(): boolean {
    return this.authService.can(Permissions.EditFumCarrier);
  }

  get canEditNotes(): boolean {
    return this.authService.can(Permissions.EditFumCarrier);
  }
}

export enum FUMCarrierViews {
  Addresses = 'addresses',
  CertificationsNotes = 'certifications-notes',
  Contacts = 'contacts',
  AssociationIdentities = 'association-identities',
  SettingsDocuments = 'settings-documents',
  Insurance = 'insurance',
  LoadHistory = 'load-history'
}
